// extracted by mini-css-extract-plugin
export default {"badge":"restricted-badge_badge__vJlwR"};